export const SPINS_OUTLETS_QUERY = '{outlets(channelSourceName: "SPINS", active: true){index name}}';